import { render, staticRenderFns } from "./news-target.vue?vue&type=template&id=7d9feeec&scoped=true&"
import script from "./news-target.vue?vue&type=script&lang=js&"
export * from "./news-target.vue?vue&type=script&lang=js&"
import style0 from "./news-target.vue?vue&type=style&index=0&id=7d9feeec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d9feeec",
  null
  
)

export default component.exports